import styled, { css } from 'styled-components'
import styledTheme from '../../styles/theme'
import Button from '@material-ui/core/Button'
import { ContainerHeading, ContainerHeadingTextDiv, ContainerHeadingActionIconsDiv, ContainerHeadingActionIcon } from '../../styles/styled-elements'

export { styledTheme, ContainerHeading, ContainerHeadingTextDiv, ContainerHeadingActionIconsDiv, ContainerHeadingActionIcon }

export const Form = styled.form`
  width: 100%;
  padding: 0 40px;
  @media (min-width: 768px) {
    width: 400px;
  }
`
export const FieldsWrapper = styled.div`
  margin: 20px 0;
`
export const FieldDiv = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }
`
export const SubmitWrapper = styled.div`
  text-align: center;
  padding: 20px 0;
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }
`
export const DataViewModalContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 10px;
  right: 10px;
  top: 10px;
  bottom: 10px;
  border: 1px solid ${styledTheme.border_grey};
  background-color: #FFF;
  z-index: 2;
`
export const GraphContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
`
export const GraphContainer = styled.div`
  display: inline-flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const DataTableModalContainer = styled(DataViewModalContainer)`
`
export const TableContainer = styled.div`
  display: inline-flex;
  flex: 1;
  width: 100%;
  overflow: scroll;
`
export const CellVerticalPadding = css`
  padding-top: 10px;
  padding-bottom: 10px;
`
export const Table = styled.table`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  border-collapse: collapse;
  margin-bottom: 10px;
  width: 100%;
`
export const THead = styled.thead`
  th:first-child {
      padding-right: 40px;
      max-width: unset !important;
  }
  th:last-child {
      width: 100%;
  }
`
export const TBody = styled.tbody`
  td:first-child {
      padding-right: 40px;
      max-width: unset !important;
  }
  td:last-child {
      width: 100%;
  }
`
export const HeaderRow = styled.tr`
`
export const HeaderCell = styled.th`
  text-align: ${({first}) => first ? 'left' : 'right' };
  padding-left: ${({first}) => first ? '0' : '25px' };
  padding-top: 16px;
  padding-bottom: 0px;
  padding-left: 10px;
  padding-right: 10px;
  width: fit-content;
  max-width: 120px;
  white-space: nowrap;
`
export const UnitsRow = styled.tr`
`
export const UnitCell = styled.td`
  text-align: ${({first}) => first ? 'left' : 'right' };
  padding-left: ${({first}) => first ? '0' : '25px' };
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  width: fit-content;
  max-width: 120px;
  white-space: nowrap;
`
export const DataRow = styled.tr`
  ${CellVerticalPadding}
  &:nth-child(even) {
    background-color: #EDEDED;
  }
`
export const DataCell = styled.td`
  ${CellVerticalPadding}
  text-align: right;
  border-top: 1px solid #CCC;
  padding-left: 10px;
  padding-right: 10px;
  width: fit-content;
  max-width: 120px;
  white-space: nowrap;
`
export const DataTableFooter = styled.div`
  border-top: 1px solid ${styledTheme.border_grey};
  background-color: white;
  display: inline-flex;
  height: 40px;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 10px;
`
export const DownloadButton = styled(Button)`
  border-radius: 2px !important;
  min-height: unset !important;
  font-size: 12px !important;
  padding: 4px 8px !important;
`



// WEBPACK FOOTER //
// ./src/components/dataViews/styled-elements.js